import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { t } from '@/locale/index.js'

/** 考勤页 i18n：监听语言切换并刷新 label */
export function useAttendancePageI18n(applyLabels) {
  const { locale } = useI18n()
  watch(locale, () => applyLabels())
  return { t, locale }
}

export { t }
